import { ActionCreator, Dispatch } from "redux";
import ActionTypes from "./ActionTypes";
import API from "api";

declare var window: any;

const oneSignalPlayerIdMapping = (externalUserId: any) => {
  const OneSignal = window.OneSignal || [];
  OneSignal.push(function () {
    OneSignal.push(() => {
      OneSignal.setExternalUserId(externalUserId);
    });
    // OneSignal.on('subscriptionChange', (isSubscribed:any) => {
    //   if (isSubscribed) {
    //     // The user is subscribed
    //     //   Either the user subscribed for the first time
    //     //   Or the user was subscribed -> unsubscribed -> subscribed
    //     OneSignal.push(() => {
    //       OneSignal.setExternalUserId(externalUserId);
    //     });
    //   }
    // });
  });
};

export const setTheme: ActionCreator<any> =
  (theme) => async (dispatch: Dispatch) => {
    // TODO set theme
    dispatch({ type: ActionTypes.SET_THEME, payload: { theme } });
  };

export const toggleTwoFactor: ActionCreator<any> =
  () => async (dispatch: Dispatch) => {
    // TODO set theme
    dispatch({ type: ActionTypes.TOGGLE_TWO_FACTOR });
  };

export const fetchUserProfile: ActionCreator<any> =
  () => async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.USER_REQUEST });
    try {
      const res = await API.fetchUserProfile();
      if (res?.result) {
        oneSignalPlayerIdMapping(res?.result.id);
        dispatch({
          type: ActionTypes.USER_SUCCESS,
          payload: { data: res?.result },
        });
      } else {
        dispatch({
          type: ActionTypes.USER_FAIL,
          payload: {
            message: res.statusCode === 401 ? "unauthorize" : res.msg,
          },
        });
      }
    } catch (e) {
      dispatch({ type: ActionTypes.USER_FAIL });
    }
  };
